import { render, staticRenderFns } from "./BasketDetails.vue?vue&type=template&id=3e7339e1"
import script from "./BasketDetails.vue?vue&type=script&lang=js"
export * from "./BasketDetails.vue?vue&type=script&lang=js"
import style0 from "./BasketDetails.vue?vue&type=style&index=0&id=3e7339e1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports